import { createApi } from '@reduxjs/toolkit/query/react';
import { createCustomFetchBaseQuery } from '../baseQuery';

export const resourcePackageApi = createApi({
  reducerPath: 'resourcePackageApi',
  baseQuery: createCustomFetchBaseQuery(),
  tagTypes: ['ResourcePackage'],
  endpoints: (builder) => ({
    getAllResourcePackages: builder.query({
      query: ({ pageno, search, sortOrder, sortBy, limit, disablePagination }) => {
        let url = `/admin/resource-packages?pageno=${pageno}`;

        if (search) {
          url += `&search=${search}`;
        }

        if (sortOrder && sortBy) {
          url += `&sortOrder=${sortOrder}&sortBy=${sortBy}`;
        }

        if (limit) {
          url += `&limit=${limit}`;
        }

        if (disablePagination) {
          url += `&disablePagination=true`;
        }

        return {
          url,
          method: 'GET',
        };
      },
      providesTags: ['ResourcePackage'],
    }),

    getResourcePackage: builder.query({
      query: (id) => ({
        url: `/admin/resource-package/${id}`,
        method: 'GET',
      }),
      providesTags: ['ResourcePackage'],
    }),

    addResourcePackage: builder.mutation({
      query: (data) => ({
        url: '/admin/resource-package',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['ResourcePackage'],
    }),

    updateResourcePackage: builder.mutation({
      query: ({ id, data }) => ({
        url: `/admin/resource-package/${id}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['ResourcePackage'],
    }),

    deleteResourcePackage: builder.mutation({
      query: (id) => ({
        url: `/admin/resource-package/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['ResourcePackage'],
    }),
  }),
});

export const {
  useGetAllResourcePackagesQuery,
  useGetResourcePackageQuery,
  useAddResourcePackageMutation,
  useUpdateResourcePackageMutation,
  useDeleteResourcePackageMutation,
} = resourcePackageApi;
